<div class="dialog-login dialog">

    <h3 mat-dialog-title class="text-center">Connexion</h3>

    <mat-dialog-content>
        <form [formGroup]="form" class="d-flex flex-column" id="login-form-wrapper">
            <mat-form-field appearance="outline">
                <mat-label>Identifiant</mat-label>
                <input matInput type="text" placeholder="Identifiant" aria-label="Identifiant" aria-describedby="user"
                    formControlName="login">
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Mot de passe</mat-label>
                <input matInput type="password" placeholder="Mot de passe" aria-label="Mot de passe"
                    aria-describedby="pwd" formControlName="password">
            </mat-form-field>
            <!-- <div class="input-group mb-3">
            <span class="input-group-text" id="user">
                <img src="/assets/icons/svg/user.svg" alt="user" draggable="false" class="icon">
            </span>
            
        </div> -->

            <!-- <div class="input-group mb-3">
            <span class="input-group-text" id="pwd">
                <img src="/assets/icons/svg/lock.svg" alt="user" draggable="false" class="icon">
            </span>
            <input type="password" class="form-control" placeholder="Mot de passe" aria-label="Mot de passe"
                aria-describedby="pwd" formControlName="password">
        </div> -->

            <div class="buttons-wrapper">
                @if (isloading) {
                <aoe-loading-spinner>
                    <span info>Connexion en cours</span>
                </aoe-loading-spinner>
                } @else {
                <button matButton="filled" [disabled]="!isFormValid" type="submit" (click)="onSubmit()">Se
                    connecter</button>
                <button matButton="outlined" type="button" (click)="createAccount()">Créer un
                    compte</button>
                }

            </div>

            @if (err) {
            <div class="errors">

                @switch (err.code) {
                @case (4012) {
                Les identifiants sont incorrects
                }
                @case (4013) {
                Vous n'êtes pas autorisés à vous connecter à cette application
                }
                @case(4041) {
                Les identifiants sont incorrects
                }
                @default {
                Une erreur est survenue. Veuillez réessayer ultérieurement
                }
                }

            </div>
            }


        </form>
    </mat-dialog-content>


    <div class="infos-followers">
        La connexion est uniquement destinée aux organisateurs et institutions. En tant que visiteur, vous pouvez
        consulter les resultats sans connexion.
    </div>



</div>